export const OSS_IMAGE_PREFIX = 'https://yuyuan-s.oss-cn-chengdu.aliyuncs.com/'
export const CDN_IMAGE_PREFIX = 'https://cdn.yuyuankj.cn/'

export const isCachedOssImageUrl = (url) => (
  typeof url === 'string' && [OSS_IMAGE_PREFIX, CDN_IMAGE_PREFIX].some(prefix => url.startsWith(prefix))
)

export const getOssImageCrossorigin = (url) => (
  isCachedOssImageUrl(url) ? 'anonymous' : undefined
)

export const getOssMediaCrossorigin = getOssImageCrossorigin

const clickDownloadLink = (url, fileName) => {
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.rel = 'noopener'
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadMediaThroughCache = async (url, fileName, mediaType = 'image') => {
  if (!isCachedOssImageUrl(url)) {
    clickDownloadLink(url, fileName)
    return
  }

  const response = await fetch(url, {
    mode: 'cors',
    credentials: 'omit',
    headers: {
      Accept: mediaType === 'audio' ? 'audio/*' : 'image/*'
    }
  })

  if (!response.ok) {
    throw new Error(`Media download failed with status ${response.status}`)
  }

  const objectUrl = URL.createObjectURL(await response.blob())
  try {
    clickDownloadLink(objectUrl, fileName)
  } finally {
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0)
  }
}

export const downloadImageThroughCache = (url, fileName) => downloadMediaThroughCache(url, fileName, 'image')

export const downloadAudioThroughCache = async (url, fileName) => {
  try {
    const response = await fetch(url, { mode: 'cors', credentials: 'omit', headers: { Accept: 'audio/*' } })
    if (!response.ok) throw new Error(`Audio download failed with status ${response.status}`)
    const objectUrl = URL.createObjectURL(await response.blob())
    try { clickDownloadLink(objectUrl, fileName) } finally { window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0) }
  } catch (error) {
    clickDownloadLink(url, fileName)
  }
}
